import { Close as CloseIcon } from "@mui/icons-material";
import { Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useRef } from "react";
import { useDispatch } from "react-redux";

import { SORT_FIELD, SORT_ORIENTATION } from "@/constants";
import { useContentElementsData, useElementMediaItemsData, useUrlParams } from "@/hooks";
import { resetCurrentElement, setElementsDialog, setSimpleValue } from "@/store/actions";
import { resetSlideToIndex } from "@/store/v2/swiper/actions";

import ElementTabs from "../ElementsTabs/ElementsTabs";

const useStyles = makeStyles({
  modalPopup: {
    padding: "0",
    position: "relative",
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  popupHeader: {
    padding: "0px",
    backgroundColor: "#000",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    height: "32px",
    marginBottom: "32px",
  },
  popupHeaderInfo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  popupHeaderText: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#fff",
  },
  popupClose: {
    color: "#757575",
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  },
  popupContent: {
    padding: "32px",
    margin: "0 auto",
    width: "960px",
    maxWidth: "960px",
    backgroundColor: "#000",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    borderRadius: "32px",
    border: "1px solid #fff",
    "@media (max-width:960px)": {
      margin: "0 20px",
    },
  },
  popupMainContent: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    flex: 1,
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  modalDialog: {
    "& > div > .MuiPaper-root": {
      backgroundColor: "transparent",
    },
    "& .MuiDialogActions-root": {
      paddingTop: "38px",
      margin: "0 auto",
      maxWidth: "500px",
      paddingLeft: "10px",
      justifyContent: "center",
    },
    "& .MuiIconButton-root": {
      padding: "0px",
    },
  },
});

// interface ElementsDialogProps {
//   open: proptypes.bool,
// };

export default function ElementsDialog(props) {
  const { open = false } = props;
  const dispatch = useDispatch();

  const classes = useStyles();
  const headerRef = useRef();
  const centerRef = useRef();

  const { propertyId } = useUrlParams();

  useContentElementsData({
    propertyId,
    sortField: SORT_FIELD.ELEMENT_CREATED_AT,
    sortOrientation: SORT_ORIENTATION.ASC,
  });

  useElementMediaItemsData({
    propertyId,
    sortField: SORT_FIELD.MEDIA_ITEM_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
  });

  const onCloseDialog = () => {
    dispatch(setElementsDialog(false));
    dispatch(resetSlideToIndex());
    dispatch(setSimpleValue("selectedElementId", null));
    dispatch(resetCurrentElement());
  };

  const onContentClick = (e) => {
    if (e.target.id && e.target.id.indexOf("menu-item") > -1) {
      return;
    }
    if (
      e.target.className &&
      typeof e.target.className === "string" &&
      e.target.className.indexOf("MuiBackdrop") > -1
    ) {
      return;
    }
    if (e.button !== 2 && !headerRef.current.contains(e.target) && !centerRef.current.contains(e.target)) {
      const listener = async () => {
        await onCloseDialog();
      };
      e.target.addEventListener("mouseup", listener);
    }
  };

  return (
    <Dialog
      className={classes.modalDialog}
      fullScreen
      open={open}
      onClose={onCloseDialog}
      aria-labelledby="elements-dialog-title"
      hideBackdrop
      PaperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <DialogContent className={classes.modalPopup} onMouseDown={onContentClick}>
        <div className={classes.popupContent} ref={centerRef}>
          <div className={classes.popupHeader} ref={headerRef}>
            <div className={classes.popupHeaderInfo}>
              <Typography className={classes.popupHeaderText}>Elements</Typography>
            </div>
            <span className={classes.popupClose}>
              <IconButton
                size="small"
                className={classes.popupClose}
                onClick={onCloseDialog}
                data-analytics="element-modal-close"
              >
                <CloseIcon />
              </IconButton>
            </span>
          </div>
          <div className={classes.popupMainContent}>
            <ElementTabs />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
